/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCenterScheduleException
 */
export interface ClaimCenterScheduleException {
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    reason: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    localEndTime: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    localStartTime: string;
    /**
     * ISO8601 local date string , e.g. 2025-04-16
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    localDate: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterScheduleException
     */
    claimCenterId: string;
}

/**
 * Check if a given object implements the ClaimCenterScheduleException interface.
 */
export function instanceOfClaimCenterScheduleException(value: object): value is ClaimCenterScheduleException {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('localDate' in value) || value['localDate'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimCenterId' in value) || value['claimCenterId'] === undefined) return false;
    return true;
}

export function ClaimCenterScheduleExceptionFromJSON(json: any): ClaimCenterScheduleException {
    return ClaimCenterScheduleExceptionFromJSONTyped(json, false);
}

export function ClaimCenterScheduleExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterScheduleException {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'localDate': json['localDate'],
        'customerId': json['customerId'],
        'id': json['id'],
        'claimCenterId': json['claimCenterId'],
    };
}

export function ClaimCenterScheduleExceptionToJSON(value?: ClaimCenterScheduleException | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'localDate': value['localDate'],
        'customerId': value['customerId'],
        'id': value['id'],
        'claimCenterId': value['claimCenterId'],
    };
}

